/* -------------------------------------------------------------------------- *
 * Google Maps Integration *
 * -------------------------------------------------------------------------- */

/* global google, MARKER_ARR */

let map;
let map_bounds;

// Adds a new marker to the map
function newMarker(position, title) {
    const marker_options = {
        map,
        position,
        title,
    };
    const marker = new google.maps.Marker(marker_options);

    // Extend the map bounds to include the marker
    map_bounds.extend(marker.getPosition());
}

/* ------------- *
 * Module Export *
 * ------------- */

const Map = {
    init() {
        const map_el = document.getElementById('js-map');

        // Create the map
        map = new google.maps.Map(map_el);
        map_bounds = new google.maps.LatLngBounds();

        MARKER_ARR.forEach((marker) => {
            newMarker(marker.position, marker.title);
        });

        // Position the map to fit all markers
        map.fitBounds(map_bounds);

        // Prevent max zoom when there is one marker
        google.maps.event.addListenerOnce(map, 'bounds_changed', () => {
            if (map.getZoom() > 13) {
                map.setZoom(13);
            }
        });
    },
};

export default Map;
